// react-query
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { queryBroadcastChannel } from "./utils";

// react-query 기존 옵션
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      // staleTime: 1000 * 20, // 20초
      staleTime: 1000 * 5 * 60, // 5분
    },
  },
});

export default function ReactQueryProvider(props: { children: React.ReactNode }) {
  queryBroadcastChannel.onmessage = (event) => {
    const queryKey = event.data;
    if (Array.isArray(queryKey)) {
      queryClient.invalidateQueries({ queryKey });
    }
  };

  return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
}
